import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataOffers from "@/data/AdminPanel/DataOffers";
import ApiEnter from "@/api/ApiEnter";
import ApiOffer from "@/api/ApiOffer";
import sweetalert from "sweetalert";
import ApiAdmin from "@/api/ApiAdmin";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@/data/CKeditor/config";
import UtilGeneral from "@/util/Common/UtilGeneral";
import { EIncludeTariffs } from "@/struct/offers/EIncludeTariffs";
import ApiRegion from "@/api/ApiRegion";
let OfferEdit = class OfferEdit extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.editorConfig = CKEditor.editorConfig(ApiEnter.CurrentSessionUUID);
        this.Breadcrumbs = DataOffers.OfferEditBreadcrumbs;
        this.OffersCategories = [];
        this.emsOffers = [];
        this.selectOffer = null;
        this.emsOffer = null;
        this.filteredOfferOperators = [];
        this.newOffer = {
            name: "",
            priority: "",
            publish: true,
            deprecated: false,
            category: [],
            price: "",
            renewalPrice: "",
            discountPrice: "",
            duration: 1,
            data: "",
            sms: "",
            min: "",
            additional_data: "",
            additional_price_info: "",
            sticker_text: "",
            overview: "",
            note: "",
            display_for_new: false,
            display_for_current: false,
            tariff_overview: "",
            prospects_info: null,
            prospects_info_name: "",
            title: "",
            description: "",
            additional_description: "",
            selectedTariffs: [],
            keywords: "",
            url: "",
            facility_id: null,
            operator: "",
        };
        this.HasLoading = false;
        this.tariffItems = [
            {
                text: "Бесплатный Транспорт",
                value: EIncludeTariffs.FreeTransport,
            },
            {
                text: "Бесплатные Соц. сети",
                value: EIncludeTariffs.FreeSocials,
            },
            {
                text: "Бесплатные Мессенджеры",
                value: EIncludeTariffs.FreeMessengers,
            },
            {
                text: "Бесплатная Музыка",
                value: EIncludeTariffs.FreeMusik,
            },
            {
                text: "Бесплатное Видео",
                value: EIncludeTariffs.FreeVideo,
            },
        ];
        this.selectRegion = null;
        this.selectedFacility = null;
        this.defaultRegion = null;
        this.regionItems = [];
    }
    async getCMSRegions() {
        this.HasLoading = true;
        try {
            const regions = await ApiRegion.GetRegions();
            this.regionItems = regions.map((item) => ({
                name: item.display_name,
                facility_id: item.facility_id,
                default: item.default,
            }));
        }
        catch (e) {
            console.error(e);
        }
        this.HasLoading = false;
    }
    async getOfferOperators() {
        this.HasLoading = true;
        try {
            const operators = await ApiOffer.GetOfferOperators(ApiEnter.CurrentSessionUUID);
            if (operators) {
                this.filteredOfferOperators = operators.filter((operator) => !operator.is_archived);
            }
        }
        catch (e) {
            console.error(e);
        }
        this.HasLoading = false;
    }
    async getOfferInfo() {
        const offerInfo = await ApiOffer.GetOfferByUUID(ApiEnter.CurrentSessionUUID, this.CurrentOfferUUID);
        if (offerInfo == undefined) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            }).then(() => {
                this.$router.go(-1);
            });
            return;
        }
        this.newOffer.name = offerInfo.name;
        this.newOffer.priority = offerInfo.priority;
        this.newOffer.publish = offerInfo.publish;
        this.newOffer.deprecated = !!offerInfo.deprecated;
        this.newOffer.price = String(offerInfo.price);
        this.newOffer.renewalPrice = String(offerInfo.renewal_price);
        this.newOffer.discountPrice =
            offerInfo.discount_price != null ? String(offerInfo.discount_price) : "";
        this.newOffer.duration = offerInfo.duration ?? 1;
        this.newOffer.data = offerInfo.data;
        this.newOffer.sms = offerInfo.sms;
        this.newOffer.min = offerInfo.min;
        this.newOffer.additional_data = offerInfo.additional_data;
        this.newOffer.additional_description = offerInfo.additional_description;
        this.newOffer.additional_price_info = offerInfo.additional_price_info;
        this.newOffer.sticker_text = offerInfo.sticker_text;
        this.newOffer.operator = offerInfo.operator;
        this.newOffer.overview = offerInfo.overview;
        this.newOffer.note = offerInfo.note;
        this.newOffer.design = offerInfo.design;
        this.newOffer.display_for_new = offerInfo.display_for_new;
        this.newOffer.display_for_current = offerInfo.display_for_current;
        if (offerInfo.prospects_info) {
            try {
                const response = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.prospects_info);
                this.newOffer.prospects_info = new File([new Blob([response.data])], offerInfo.prospects_info.split("/")[8]);
            }
            catch (error) {
                console.error("Ошибка при загрузке файла prospects_info:", error);
                this.newOffer.prospects_info = null;
            }
        }
        else {
            this.newOffer.prospects_info = null;
        }
        this.newOffer.prospects_info_name = offerInfo.prospects_info;
        this.selectRegion = offerInfo.facility_id;
        this.selectedFacility = offerInfo.facility_id;
        if (this.selectedFacility == undefined) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            }).then(() => {
                this.$router.go(-1);
            });
            return;
        }
        if (offerInfo.ems_product_name != null &&
            offerInfo.ems_product_id != null) {
            this.emsOffer = {
                name: offerInfo.ems_product_name,
                id: offerInfo.ems_product_id,
            };
            this.selectOffer = offerInfo.ems_product_id;
        }
        this.newOffer.title = offerInfo.title;
        this.newOffer.description = offerInfo.description;
        this.newOffer.keywords = offerInfo.keywords;
        this.newOffer.url = offerInfo.url;
        const service = JSON.parse(offerInfo.service);
        this.newOffer.selectedTariffs = service
            ? service.map((item) => item.value)
            : [];
    }
    filterOffer() {
        this.emsOffer = this.emsOffers.find((item) => item.id === this.selectOffer);
    }
    async filterRegion() {
        if (this.selectRegion) {
            const selectedRegion = this.regionItems.find((item) => item.facility_id === this.selectRegion);
            if (selectedRegion) {
                this.selectedFacility = selectedRegion.facility_id;
                await this.getCMSOffers(this.selectedFacility);
            }
        }
        else {
            this.selectedFacility = parseInt(process.env.VUE_APP_FACILITY_ID);
            await this.getCMSOffers(this.selectedFacility);
        }
    }
    isChecked(value) {
        return this.newOffer.selectedTariffs.includes(value);
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        try {
            let service = this.tariffItems.filter((item) => this.newOffer.selectedTariffs.includes(item.value));
            if (service.length === 0) {
                service = [];
            }
            const response = await ApiOffer.UpdateOfferInfo(this.newOffer.name, this.newOffer.priority, this.newOffer.publish ? 1 : 0, this.newOffer.deprecated ? 1 : 0, this.newOffer.price, this.newOffer.data, this.newOffer.sms, this.newOffer.min, this.newOffer.additional_data, this.newOffer.additional_price_info, this.newOffer.sticker_text, this.newOffer.overview, this.newOffer.note, this.newOffer.display_for_new ? 1 : 0, this.newOffer.display_for_current ? 1 : 0, this.newOffer.tariff_overview, this.newOffer.prospects_info != null
                ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info, this.newOffer.prospects_info_name))
                : "", this.newOffer.title, this.newOffer.description, this.newOffer.additional_description, this.emsOffer ? this.emsOffer?.id : null, this.emsOffer ? this.emsOffer?.name : null, this.newOffer.keywords, this.newOffer.url, this.newOffer.renewalPrice, this.newOffer.discountPrice || null, Number(this.newOffer.duration) || 1, JSON.stringify(service.sort((a, b) => a.value - b.value)), ApiEnter.CurrentSessionUUID, this.selectRegion ? this.selectRegion : this.newOffer.facility_id, this.newOffer.operator, this.CurrentOfferUUID);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.$router.go(-1);
                });
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.HasLoading = false;
    }
    CopyLink(link) {
        UtilGeneral.CopyLink(link);
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    ValidateSeoUrl() {
        this.newOffer.url = this.Translit(this.newOffer.url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
    }
    async DownloadProspectsInfo() {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info_name).then((response) => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = this.newOffer.prospects_info_name.split("/")[8];
            a.click();
        });
    }
    async getCMSOffers(facility_id) {
        try {
            const response = await ApiOffer.GetEMSOffers(ApiEnter.CurrentSessionUUID, "main", facility_id || process.env.VUE_APP_FACILITY_ID);
            if (typeof response != "boolean") {
                this.emsOffers = response;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    created() {
        this.CurrentOfferUUID = this.$route.params.offer_uuid;
        this.getCMSRegions();
        this.getOfferOperators();
        this.getOfferInfo().then(() => {
            this.getCMSOffers(this.selectedFacility);
        });
    }
};
__decorate([
    Prop()
], OfferEdit.prototype, "initialSelectRegion", void 0);
OfferEdit = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], OfferEdit);
export default OfferEdit;
